import { jsx as _jsx } from "react/jsx-runtime";

function SvgTooltip() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-10.932 1.229c0-.04.004-.08.01-.121.038-.227.09-.426.16-.598.15-.378.426-.75.825-1.114.404-.37.673-.668.806-.896.133-.232.2-.476.2-.731 0-.77-.346-1.156-1.039-1.156-.329 0-.687.105-.886.315-.177.185-.27.436-.293.753V9.7c0 .525-.414.95-.926.95a.935.935 0 01-.922-.868V9.77a.989.989 0 01.013-.244c.071-.754.42-1.378.903-1.82C10.46 7.211 11.098 7 12.03 7c.941 0 1.671.235 2.19.704C15 8.5 15 9.112 15 9.68c0 .387-.084.754-.253 1.1-.169.342-.464.723-.886 1.142l-.54.526-.029.03c-.309.304-.329.324-.478.922-.05.45-.42.8-.872.8a.889.889 0 01-.874-.971zM12.897 16c0 .552-.437 1-.975 1a.987.987 0 01-.974-1c0-.552.436-1 .974-1s.975.448.975 1z"
    }, void 0)
  }), void 0);
}

export default SvgTooltip;